import EditSceneCaptionsLayer from './EditSceneCaptionsLayer';

export default EditSceneCaptionsLayer;
